export const getInstitutionLinkedProps = (inst,provider) => {
    const { name : institution_name, url : institution_url  } = inst;
    return {institution_name, institution_url, link_provider : provider};
}
